import React from "react";
import {observer} from "mobx-react";
import {Badge, Button, Card, Col, Container, Row} from "react-bootstrap";

function ResellerDashboard() {

    return (
        <Container className="dashboard-shell">
            <div className="dashboard-hero" data-accent="reseller">
                <div>
                    <div className="dashboard-eyebrow">Reseller Portal</div>
                    <h1>Partner workspace</h1>
                    <p>Track your client activity and place new tax certificate orders quickly.</p>
                </div>
                <div className="dashboard-hero-actions">
                    <Button variant="primary" href="/order/new">New Order</Button>
                    <Button variant="outline-secondary" href="/customer/orders">My Orders</Button>
                </div>
            </div>

            <Row className="mt-4 g-3">
                {[
                    {label: "Client Orders", value: "N/A"},
                    {label: "Pending Follow-ups", value: "N/A"},
                    {label: "Recent Activity", value: "N/A"}
                ].map((stat) => (
                    <Col md={4} key={stat.label}>
                        <Card className="stat-card">
                            <Card.Body>
                                <div className="stat-label">{stat.label}</div>
                                <div className="stat-value">{stat.value}</div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Row className="mt-4 g-4">
                <Col lg={8}>
                    <Card className="dashboard-panel">
                        <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                            <strong>Quick Actions</strong>
                            <Badge bg="light" text="dark">Reseller tools</Badge>
                        </Card.Header>
                        <Card.Body>
                            <Row className="g-3">
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-plus-circle"></i></div>
                                        <div>
                                            <h6>Start a New Order</h6>
                                            <p className="text-muted mb-2">Create a certificate request for a client.</p>
                                            <Button variant="outline-primary" href="/order/new">Create Order</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-bag-check"></i></div>
                                        <div>
                                            <h6>Review Orders</h6>
                                            <p className="text-muted mb-2">Check recent orders and download certificates.</p>
                                            <Button variant="outline-primary" href="/customer/orders">View Orders</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-people"></i></div>
                                        <div>
                                            <h6>Client Activity</h6>
                                            <p className="text-muted mb-2">Monitor key client requests and follow-ups.</p>
                                            <Button variant="outline-secondary" href="/customer/orders">Review</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-graph-up"></i></div>
                                        <div>
                                            <h6>Reporting</h6>
                                            <p className="text-muted mb-2">Stay on top of volume and fulfillment metrics.</p>
                                            <Button variant="outline-secondary" href="/customer/orders">Open</Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={4}>
                    <Card className="dashboard-panel mb-4">
                        <Card.Body>
                            <h5 className="mb-2">Reseller Insights</h5>
                            <p className="text-muted mb-3">Keep your clients moving by pre-filling references and search types.</p>
                            <Button variant="outline-secondary" href="/order/new">Start with a Template</Button>
                        </Card.Body>
                    </Card>
                    <Card className="dashboard-panel">
                        <Card.Body>
                            <h6 className="mb-2">Need help?</h6>
                            <p className="text-muted mb-3">Reach out to the BCTC team for onboarding or billing support.</p>
                            <Button variant="primary" href="/customer/orders">Contact Support</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default observer(ResellerDashboard);
